import classNames from 'classnames/bind';
import styles from './notOverYetBanner.module.scss';

const cx = classNames.bind(styles);

const NotOverYetBanner = () => {
  const userName = '';

  return (
    <div className={cx('bannerArea')}>
      <em className={cx('title')}>아직 끝이 아니에요!</em>

      <p className={cx('desc')}>
        여기서부턴 {userName}님이 가장 역량을 잘 펼칠 수 있는
        <br />
        최적의 기업문화와 직군을 추천해 줄게요!
      </p>
    </div>
  );
};

export default NotOverYetBanner;
